import { useCallback } from "react";
import { useBooleanFlag } from "@apac/feature-flags";
import { useI18nContext } from "@hopper-b2b/i18n";
import { isValidCardNumber, FeatureFlagNames } from "@hsbc/utilities";

export const useCardNumberValidator = () => {
  const { t } = useI18nContext();
  const disableBinCheck = useBooleanFlag(FeatureFlagNames.DISABLE_BIN_CHECK);
  return useCallback(
    (cardNumber: string) => {
      if (disableBinCheck) return;
      if (!isValidCardNumber(cardNumber.replace(/\s/g, ""))) {
        return t("paymentForm.errors.notHsbcCardError");
      }
    },
    [t, disableBinCheck]
  );
};
